import { makeStyles, TextField } from '@material-ui/core';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { format as DateFormat } from 'date-fns';
import moment from 'moment';
import React, { useEffect, useRef } from 'react';

const useStyles = makeStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#707070',
      },
    },
  },
});

const MonthInput = (props) => {
  const classes = useStyles();

  const {
    id,
    label,
    format = 'MM/YYYY',
    dateFormat = 'MM/yyyy',
    fullWidth,
    disableFuture,
    onChange,
    onBlur,
    value,
    readOnly,
    error,
    helperText = 'Campo é obrigatório',
    touched,
    autoFocus,
    getInputRef,
  } = props;
  const ref = useRef(null);

  const getRef = () => {
    if (getInputRef) {
      return getInputRef();
    }
    return ref;
  };
  const inputRef = getRef();

  useEffect(() => {
    if (autoFocus) {
      inputRef.current.focus();
    }
  }, [inputRef, autoFocus]);

  if (readOnly) {
    return <TextField disabled id={id} label={label} defaultValue={value && DateFormat(new Date(value), dateFormat)} />;
  }

  return (
    <KeyboardDatePicker
      autoOk
      inputRef={inputRef}
      id={id}
      name={id}
      label={label}
      format={format}
      fullWidth={fullWidth}
      disableFuture={disableFuture}
      value={value}
      className={classes.root}
      error={Boolean(error)}
      InputLabelProps={{ shrink: true }}
      helperText={error && touched && helperText}
      views={['year', 'month']}
      openTo="month"
      orientation="landscape"
      inputVariant="outlined"
      variant="dialog"
      onChange={(_, date) => {
        onChange({
          target: {
            id,
            name: id,
            value: date ? moment(date, dateFormat) : null,
          },
        });
      }}
      onBlur={onBlur}
      invalidDateMessage="Data é inválida"
    />
  );
};

export default MonthInput;
